// extracted by mini-css-extract-plugin
export default {"modal":"ReportAdModal-module__modal___Ecjv-"};